import React from 'react';
import { FiShoppingBag, FiPlus } from 'react-icons/fi';

const ESTADO_LABEL = {
  pendiente: 'Pendiente',
  en_revision: 'En revision',
  aprobado: 'Por pagar',
  esperando_pago: 'Por pagar',
  pago_en_verificacion: 'Verificando',
  pagado: 'Pagado',
  armado_cocina: 'Armando',
  armado: 'Armando',
  listo: 'Listo',
  despachado: 'Despachado',
  en_camino: 'En camino',
  llegada: 'Llegada',
  entregado: 'Entregado',
  rechazado: 'Rechazado',
  cancelado: 'Cancelado',
  credito_pagado: 'Credito pagado',
};

const S = {
  wrapper: {
    display: 'flex',
    gap: '8px',
    padding: '8px 12px',
    overflowX: 'auto',
    borderBottom: '1px solid var(--color-border)',
    background: 'var(--color-surface)',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    scrollbarWidth: 'none',
  },
  tab: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '7px 12px',
    borderRadius: '999px',
    border: '1px solid var(--color-border)',
    background: 'var(--color-bg)',
    color: 'var(--color-text-secondary)',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    flexShrink: 0,
    fontFamily: 'inherit',
    transition: 'all 0.2s ease',
  },
  tabActive: {
    background: 'var(--color-primary)',
    borderColor: 'var(--color-primary)',
    color: 'var(--color-surface)',
  },
  tabNuevo: {
    borderColor: 'var(--color-secondary)',
    borderStyle: 'dashed',
    background: 'transparent',
    color: 'var(--color-secondary)',
  },
  tabNuevoActive: {
    background: 'var(--color-secondary)',
    borderColor: 'var(--color-secondary)',
    borderStyle: 'solid',
    color: 'var(--color-surface)',
  },
  estado: {
    fontSize: '10px',
    fontWeight: 600,
    opacity: 0.75,
  },
};

function SelectorPedidos({
  pedidos = [],
  seleccionadoId,
  onSeleccionar,
  actionNode = null,
  modoNuevoPedido = false,
  onNuevoPedido = null,
}) {
  const hayPedidos = pedidos && pedidos.length > 0;
  if (!hayPedidos && !actionNode && !onNuevoPedido) return null;

  return (
    <div style={S.wrapper}>
      {onNuevoPedido && hayPedidos && (
        <button
          type="button"
          onClick={onNuevoPedido}
          style={{ ...S.tab, ...(modoNuevoPedido ? S.tabNuevoActive : S.tabNuevo) }}
        >
          <FiPlus size={13} />
          <span>Nuevo pedido</span>
          {modoNuevoPedido && <span style={S.estado}>Sin artículos</span>}
        </button>
      )}
      {pedidos.map((p) => {
        const activo = !modoNuevoPedido && parseInt(p.id) === parseInt(seleccionadoId);
        return (
          <button
            key={p.id}
            type="button"
            onClick={() => onSeleccionar && onSeleccionar(p.id)}
            style={{ ...S.tab, ...(activo ? S.tabActive : {}) }}
          >
            <FiShoppingBag size={13} />
            <span>Pedido #{p.id}</span>
            <span style={S.estado}>{ESTADO_LABEL[p.estado] || p.estado}</span>
          </button>
        );
      })}
      {actionNode}
    </div>
  );
}

export default SelectorPedidos;
